export default __webpack_public_path__ + "static/firstview-pc-be0849f6bd0202488774df12da987e44.webp";